import { lockScroll, unlockScroll } from './functions.js';

//
// team modal article
//

document.querySelectorAll('.c-article__item.team').forEach(card => {
    card.addEventListener('click', (e) => {
        const id = card.dataset.id;
        const member = teamData && teamData.find(m => m.id == id);
        if (member) {
            // Build modal HTML with all ACF fields
            const modalWrapper = document.createElement('div');
            modalWrapper.classList.add('c-modal', 'is-visible');
            modalWrapper.innerHTML = `
                <div class="c-modal__overlay"></div>
                <div class="c-modal__content">
                    <button class="c-modal__close" aria-label="Close">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <line x1="8" y1="8" x2="24" y2="24" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            <line x1="24" y1="8" x2="8" y2="24" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </button>
                    <picture class="c-modal__photo-col">
                        <img class="c-modal__photo" src="${member.photo_alt.url}" alt="${member.photo_alt || member.name}" width="${member.photo_alt.width || 644}" height="${member.photo_alt.height || 644}">
                    </picture>
                    <div class="c-modal__info-col">
                        <div class="c-modal__name-job-row">
                            <div class="c-modal__name-job-col">
                                <h2 class="c-modal__name">${member.name}</h2>
                                <p class="c-modal__job-title">${member.job_title}</p>
                            </div>
                            <div class="c-modal__name-job-col-divider"></div>
                            <div class="c-modal__year-started-row">
                                <span class="c-modal__year-label">Since:</span>
                                <span class="c-modal__year-value">${member.year_started}</span>
                            </div>
                        </div>
                        <div class="c-modal__description">
                            <h4>About me</h4>
                            ${member.job_description}
                        </div>
                        <div class="c-modal__footer-row">
                            <div class="c-modal__socials">
                                <a class="c-modal__social-linkedin" href="${member.linkedin}" target="_blank"><svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.96631 0.0283813C1.77447 0.0283813 0.00035461 1.80569 0 3.99257C0 6.18157 1.77411 7.95852 3.96667 7.95852C6.15319 7.95852 7.92979 6.18157 7.92979 3.99257C7.92979 1.80533 6.15284 0.0283813 3.96631 0.0283813Z" fill="#ACFE00"/><path d="M7.38428 10.9667H0.544922V32.9716H7.38428V10.9667Z" fill="#ACFE00"/><path d="M24.7962 10.4195C21.4692 10.4195 19.2384 12.2436 18.3252 13.9734H18.2338V10.9667H11.6742H11.6738V32.9713H18.5072V22.0855C18.5072 19.2156 19.0536 16.4358 22.6118 16.4358C26.1189 16.4358 26.1657 19.7181 26.1657 22.2695V32.9709H33.0001V20.9014C33.0001 14.9769 31.7217 10.4195 24.7962 10.4195Z" fill="#ACFE00"/></svg></a>
                                <a class="c-modal__social-email" href="mailto:${member.email}"><svg width="33" height="23" viewBox="0 0 33 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M32.5983 2.50307L21.8091 11.5L32.5983 20.4969V2.50307ZM32.0592 21.8977C31.7586 22.1767 31.3568 22.3487 30.9188 22.3487H2.08177C1.64528 22.3487 1.24494 22.1781 0.945763 21.9021L12.3103 12.4253L14.0461 13.8735C14.7298 14.443 15.6244 14.7262 16.5147 14.7219C17.4036 14.7176 18.2997 14.4285 18.9877 13.8533L20.7004 12.4253L32.0592 21.8977ZM0.402344 20.5045L11.2019 11.5001L0.402344 2.49581V20.5045ZM0.9458 1.09832C1.24498 0.820823 1.64532 0.651733 2.08181 0.651733H30.9189C31.3582 0.651733 31.76 0.823724 32.0592 1.10269L20.2555 10.9465L20.2396 10.9595L18.0803 12.7604C17.6525 13.1174 17.083 13.2966 16.5107 13.2995C15.9398 13.3024 15.3747 13.129 14.9555 12.7806L12.7731 10.961L12.7543 10.9451L0.9458 1.09832Z" fill="#ACFE00"/></svg></a>
                            </div>
                            <div class="c-modal__footer-text">
                                ${member.footer_text}
                            </div>
                        </div>
                    </div>
                </div>
            `;
            document.body.appendChild(modalWrapper);

            // Lock scroll
            if (typeof lockScroll === 'function') lockScroll();

            // Close modal on click
            modalWrapper.addEventListener('click', (event) => {
                // Close if clicking the close button or overlay (but not modal content)
                if (
                    event.target.closest('.c-modal__close') ||
                    (event.target.classList.contains('c-modal__overlay'))
                ) {
                    modalWrapper.remove();
                    if (typeof unlockScroll === 'function') unlockScroll();
                }
            });
        }
    });
});
